function isEmptyFields (data) {
    return data.length === 0 || data.length === '' 
}

function isValidEmail (data) {
    return /^(\w+\.?)+[a-z0-9]+@(\w+)\.(\w){1,4}$/g.test(data)
}

function isTelNumber (data) {
    return !isNaN(data.replaceAll(" ", ""))
}

export default Object.freeze({
    isEmptyFields,
    isValidEmail,
    isTelNumber
})